// This icon file is generated automatically.
var PWifiOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M10.3 8.7a4.98 4.98 0 00-6.57 0 .13.13 0 00-.01.17l.56.67c.05.06.13.06.18.02a3.85 3.85 0 015.11 0c.05.04.13.03.18-.02l.56-.67a.13.13 0 00-.01-.17zm1.83-2.2a7.96 7.96 0 00-10.23 0 .13.13 0 00-.02.18l.57.67c.04.06.12.06.17.02a6.86 6.86 0 018.79 0c.05.04.13.04.17-.02l.57-.67a.13.13 0 00-.02-.17zm1.82-2.17A10.95 10.95 0 00.05 4.3a.12.12 0 00-.02.18l.57.67c.04.05.12.06.17.02a9.83 9.83 0 0112.46.03c.06.04.14.03.18-.02l.56-.67a.12.12 0 00-.02-.18zM6 11.16a1 1 0 102 0 1 1 0 00-2 0z", "fill-rule": "nonzero" } }] }, "name": "p-wifi", "theme": "outlined" };
export default PWifiOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PWifiOutlined.js
// module id = 3732
// module chunks = 0